import { Component, Input, OnChanges } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { ConfigService, InjectConfig, ModelsExperienceConfigKey, SharedConfigKey } from '@ddt-web/config-layer';
import { NumberFormatter, TabData } from '@ddt-web/data-service';

import { EsgScoreImpact } from '../models';
import { EsgScoreImpactUtil } from '../utils/esg-score-impact.utils';

@Component({
	selector: 'esg-carbon-emissions-impact',
	templateUrl: './esg-carbon-emissions-impact.component.html',
	styleUrls: ['./esg-carbon-emissions-impact.component.scss']
})
export class EsgCarbonEmissionsImpactComponent implements OnChanges {

	@InjectConfig(ModelsExperienceConfigKey.ENABLE_ROUND_OFF_EQUIVALENCY_SCORE) public readonly enableRoundOff: boolean = false;

	@Input() public data: TabData;
	@Input() public asOfDate: string;

	public carbonEmissionsTranslations: Array<EsgScoreImpact> = [];
	@InjectConfig(SharedConfigKey.EsgCarbonEquivalencies)
	public readonly carbonEmissionsEquivalencies: { [equivalency: string]: number } = {};

	constructor(public contentService: ContentService, public configService: ConfigService) { }

	public ngOnChanges(): void {
		if (this.data) {
			const cells = this.data.tableData[0]?.cells;
			const headers = this.data.tableData[0]?.headersX;
			const esgMetrics = Object.keys(this.carbonEmissionsEquivalencies);

			this.carbonEmissionsTranslations = headers.map((header, index: number) => {
				let metricScore: string;
				return {
					portfolioName: header?.formattedValue,
					metrics: esgMetrics.map((equivalency) => {
						let showUnits = false;
						const icon = EsgScoreImpactUtil.getMetricIcon(equivalency, this.contentService);
						if (equivalency === 'CARBON_EMISSION_DIFFERENCE') {
							metricScore = EsgScoreImpactUtil.getCarbonEmissionDifference(cells[0][index], cells[1][index]);
						}
						else {
							metricScore = EsgScoreImpactUtil.getCarbonImpactScore(cells[0][index], equivalency, this.carbonEmissionsEquivalencies, this.enableRoundOff);
						}
						if (metricScore !== NumberFormatter.DASH_VALUE) {
							showUnits = true;
						}

						return {
							name: equivalency,
							icon,
							metricScore,
							showUnits
						};
					})
				};
			});
		}
	}

}
